import { createContext } from "react";

export const MetricaTagIDContext = createContext<number | null>(null);
